'use client'

import { memo } from 'react'

import styles from './PriceDisplay.module.scss'

const PriceDisplay = memo(
  ({
    unitPrice,
    promoUnitPrice,
    totalPrice,
    promoTotalPrice
  }: {
    unitPrice: string
    promoUnitPrice: string | null
    totalPrice: string | null
    promoTotalPrice: string | null
  }) => (
    <div className={styles.wrapper}>
      <div
        className={styles.unitPrice}
        id='cart_unit_price'
        dangerouslySetInnerHTML={{
          __html: promoUnitPrice
            ? `Cena za sztukę: <b><s data-testid='cart-product-price-old'>${unitPrice.replace(
                ',',
                '.'
              )}</s></b>  <b data-testid='cart-product-price'>${promoUnitPrice.replace(
                ',',
                '.'
              )}</b>`
            : `Cena za sztukę: <b data-testid='cart-product-price'>${unitPrice.replace(
                ',',
                '.'
              )}</b> `
        }}
      />
      <div
        className={styles.currentPrice}
        id='cart_current_price'
        dangerouslySetInnerHTML={{
          __html: promoTotalPrice
            ? `<s data-testid='cart-product-price-old'>${totalPrice?.replace(
                ',',
                '.'
              )}</s>  <span data-testid='cart-product-price'>${promoTotalPrice.replace(
                ',',
                '.'
              )}</span>`
            : `<span data-testid='cart-product-price'>${totalPrice?.replace(
                ',',
                '.'
              )}</span>`
        }}
      />
    </div>
  )
)

export default PriceDisplay
